import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=bfe6a422&scoped=true&"
import script from "./BaseIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=bfe6a422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe6a422",
  null
  
)

export default component.exports